import React, { Component } from 'react';
import styles from './styles';

import { AxlTextArea, AxlPanel, AxlButton } from 'axl-reactjs-ui';
import {inject, observer} from "mobx-react";

@inject('deliveryStore')
@observer
class ShipmentPickupForm extends Component {
  state = {
    updating: false,
    oldNote: '',
  };

  componentDidMount() {
    const { shipmentDropoffForm } = this.props.deliveryStore;
    const oldNote = shipmentDropoffForm.getField('pickup_note', '');

    this.setState({oldNote});
  }

  closeWithoutSave = () => {
    const { shipmentDropoffForm } = this.props.deliveryStore;
    shipmentDropoffForm.setField('pickup_note', this.state.oldNote);

    this.props.closeForm();
  };

  save = (e) => {
    const {deliveryStore, shipment, closeForm} = this.props;
    this.setState({updating: true})
    deliveryStore.updateShipmentPickup(shipment, (res) => {
      this.setState({updating: false})
      closeForm();
    });
  };

  render() {
    const { shipment, deliveryStore } = this.props;
    const { shipmentPickupForm } = deliveryStore;

    return <div style={styles.Container}>
      <div style={styles.HeaderTitle}>{`Edit Pickup`}</div>
      <AxlPanel>
        <AxlPanel.Row>
          <AxlPanel.Col style={styles.GroupPanel}>
            <AxlPanel.Row align={`center`}>
              <AxlPanel.Col>
                <div style={styles.GroupTitle}>{`Pickup Notes`}</div>
                <div style={styles.Field}>
                  <AxlTextArea
                    defaultValue={shipmentPickupForm.getField('pickup_note', '')}
                    onChange={shipmentPickupForm.handlerInput}
                    placeholder={`Pickup Notes`}
                    name={`pickup_note`}
                    type={`textarea`}
                    style={{minHeight: 120}}
                    fluid
                  />
                </div>
              </AxlPanel.Col>
            </AxlPanel.Row>
          </AxlPanel.Col>
        </AxlPanel.Row>
        <AxlPanel.Row>
          <AxlPanel.Col>
            <AxlPanel.Row align={`flex-end`}>
              <div style={{...styles.Field, ...styles.FieldButton}}>
                <AxlButton compact bg={`gray`}
                           onClick={this.closeWithoutSave}
                           style={styles.buttonControl}
                >
                  {`Cancel`}
                </AxlButton>
              </div>
              <div style={{...styles.Field, ...styles.FieldButton}}>
                <AxlButton compact bg={`pink`}
                           onClick={this.save}
                           style={styles.buttonControl}
                           loading={this.state.updating}
                >
                  {`Save`}
                </AxlButton>
              </div>
            </AxlPanel.Row>
          </AxlPanel.Col>
        </AxlPanel.Row>
      </AxlPanel>
    </div>
  }
}

export default ShipmentPickupForm;